import { motion } from "framer-motion";
import Seo from "../components/Seo";
import ComplianceSection from "../components/ComplianceSection";
import ResourcesSection from "../components/ResourcesSection";
import { BOOK_DEMO_URL } from "../lib/constants";

export default function Compliance() {
  return (
    <>
      <div className="fixed top-0 left-0 w-full h-full overflow-hidden -z-10 pointer-events-none">
        <div className="absolute top-[-20%] left-[-10%] w-[60vw] h-[60vw] rounded-full bg-primary/5 blur-3xl" />
        <div className="absolute top-[20%] right-[-10%] w-[50vw] h-[50vw] rounded-full bg-secondary/5 blur-3xl" />
      </div>

      <main className="flex-grow pt-16 md:pt-32 pb-section-gap px-gutter max-w-container-max mx-auto w-full">
        <Seo
          title="Compliance & Cloud Security"
          description="Auditors ask for evidence, not intentions. Cybermon continuously checks your cloud posture against the frameworks you're held to — so you can answer with proof, not paperwork."
          path="/compliance"
        />

        <section className="flex flex-col items-center text-center max-w-4xl mx-auto mb-section-gap">
          <span className="font-eyebrow text-eyebrow text-primary uppercase tracking-widest mb-stack-lg bg-primary/10 px-4 py-1.5 rounded-full border border-primary/20 flex items-center gap-2">
            <span className="w-2 h-2 rounded-full bg-primary animate-pulse" />
            Module 3
          </span>
          <motion.h1
            initial={{ opacity: 0, y: 16 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5 }}
            className="font-display-hero-mobile md:font-display-hero text-display-hero-mobile md:text-display-hero text-on-surface dark:text-surface-bright font-bold tracking-tight mb-stack-lg"
          >
            Compliance &amp; Cloud Security <br />
            <span className="text-gradient">— Proof, not paperwork.</span>
          </motion.h1>
          <p className="font-body-lg text-body-lg text-on-surface-variant dark:text-surface-variant max-w-2xl mb-10">
            Auditors ask for evidence, not intentions. Cybermon continuously checks your cloud
            posture against the frameworks you're held to — so you can answer with proof, not
            paperwork.
          </p>
          <div className="flex flex-col sm:flex-row gap-4">
            <a
              href={BOOK_DEMO_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center justify-center bg-primary-container text-on-primary-container font-label-sm px-8 py-4 rounded-full hover:scale-105 transition-transform font-semibold shadow-lg shadow-primary-container/20"
            >
              Book a Demo
            </a>
            <a
              href="#frameworks"
              className="inline-flex items-center justify-center glass-card text-on-surface dark:text-surface-bright font-label-sm px-8 py-4 rounded-full hover:bg-surface-variant/50 transition-colors font-semibold"
            >
              Explore Frameworks
            </a>
          </div>
        </section>

        <ComplianceSection />

        <ResourcesSection
          moduleKey="compliance"
          eyebrowColor="text-primary"
          heading="Take the case to your team"
          subhead="The one-page flyer for a quick share, or the full coverage document for the follow-up conversation."
        />

        <section className="text-center py-section-gap">
          <h2 className="font-headline-section text-headline-section text-on-surface dark:text-surface-bright font-semibold mb-stack-lg">
            Walk into your next audit ready.
          </h2>
          <a
            href={BOOK_DEMO_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center justify-center bg-primary-container text-on-primary-container font-label-sm px-10 py-5 rounded-full hover:scale-105 transition-transform font-bold text-lg shadow-xl shadow-primary/20"
          >
            Book a Demo
          </a>
        </section>
      </main>
    </>
  );
}
